import { put, takeEvery, select } from 'redux-saga/effects';
import { START_PAYMENT_TRANSACTION_LOADING, START_PAYMENT_TRANSACTION_SUCCESS, START_PAYMENT_TRANSACTION_ERROR } from "../actions/actionPaymentTransaction";
import { postmember } from 'api';
import { UpdateCustomerUdfs } from 'api';
import { posttransaction, postbookingtickets, apiBookingTypes } from 'api';
import { genfunction, UDFs } from 'helpers';
import AES from '../helpers/AES';
const { EnableAlternateMerchantOnline, PaymentTypeID, Merchant2TypeID, RecaptchaNumberOfCallsOnTransaction } = window['runConfig'];

async function fetchAsync(func, payload) {
    const response = await func(payload);

    if (response.status == 200) {

        if (response.url.includes('Transactions')) {

            const jVal = response.arrayBuffer();

            return await Promise.resolve(jVal).then(function (value) {
                let base64String = btoa(String.fromCharCode(...new Uint8Array(value)));
                let res = AES.decrypt(base64String);

                return JSON.parse(res);

            });
        }
        else {
            return await response.json();
        }

    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {

        if (response.url.includes('Transactions')) {

            const jVal = response.arrayBuffer();

            throw await Promise.resolve(jVal).then(function (value) {
                let base64String = btoa(String.fromCharCode(...new Uint8Array(value)));
                let res = AES.decrypt(base64String);

                if (res.includes("Payment has been unsuccessful. To make this purchase, please contact us directly.")) {
                    throw JSON.parse('{"Errors":[{"ErrorMessage":"' + RecaptchaNumberOfCallsOnTransaction + '"}]}');
                }

                return JSON.parse(res);

            });
        }
        else {
            throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to update customer, response status: " + response.status + "\"}]}");
        }
    }
    else if (response.status == 401) {
        if (response.url.includes('Transactions')) {
            throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Middleware credentials are not valid, response status: " + response.status + "\"}]}");
        }
        else {
            throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Credentials are not valid please contact administrator for more details, response status: " + response.status + "\"}]}");
        }
    }
    else if (response.status == 403) {
        if (response.url.includes('Transactions')) {

            const jVal = response.arrayBuffer();

            throw await Promise.resolve(jVal).then(function (value) {
                let base64String = btoa(String.fromCharCode(...new Uint8Array(value)));
                let res = AES.decrypt(base64String);
                return JSON.parse(res);
            });
        }
        else {
            throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to update customer not enough privileges to perform an action, response status: " + response.status + "\"}]}");
        }
    }
    else if (response.status == 422) {

        if (response.url.includes('Transactions')) {

            const jVal = response.arrayBuffer();

            return await Promise.resolve(jVal).then(function (value) {
                let base64String = btoa(String.fromCharCode(...new Uint8Array(value)));
                let res = AES.decrypt(base64String);

                throw JSON.parse(res);
            });
        }
        else {
            return await response.json();
        }
    }
    else {
        if (response.url.includes('Transactions')) {

            throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to perform transaction, response status: " + response.status + "\"}]}")
        }
        else {
            throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to update customer, response status: " + response.status + "\"}]}");
        }
    }
}


function* SavePaymentTransactionData(action) {
    try {

        const customer = action.customer[0];
        const token = action.token;
        const recaptchaToken = action.recaptchaToken;


        const events = yield select(state => state.reducerShopCart.events);
        const cashless = yield select(state => state.reducerShopCart.cashless);
        const donation = yield select(state => state.reducerShopCart.donation);
        const transactionfee = yield select(state => state.reducerTransactionFee);
        const membershipPackages = yield select(state => state.reducerShopCart.MembershipPackages);
        const gatickets = yield select(state => state.reducerShopCart.GATickets);
        const orderProducts = yield select(state => state.reducerShopCart.orderProducts);
        const orderLocation = yield select(state => state.reducerOrderLocations.orderLocation);
        const reducerBooking = yield select(state => state.reducerBooking);
        let booking = reducerBooking && reducerBooking.booking[0] ? reducerBooking.booking[0] : null;
        const managebkngTicketsModify = yield select(state => state.reducerShopCart.managebookingticketsmodification);
        const managemybooking = yield select(state => state.reducerShopCart.managemybooking);
        const refundType = yield select(state => state.reducerShopCart.refundType);
        const addamount = yield select(state => state.reducerShopCart.additionalbookingamount);
        const customers = yield select(state => state.reducerCustomer);
        const giftcards = yield select(state => state.reducerGiftCards);
        const idmeshopreducer = yield select(state => state.reducerShopCart.IDME);
        const idmeuserdata = yield select(state => state.reducerIDMeUserData);
        const bookingUDFS = yield select(state => state.reducerBookingUserDefinedFields);
        const membershipTypesUdfs = yield select(state => state.reducerMembershipUserDefinedFields);
        const membershipValidation = yield select(state => state.reducerShopCart.membershipValidation);
        const showTransFee = yield select(state => state.reducerShopCart.showTransactionFee);
        const donationProducts = yield select(state => state.reducerShopCart.donationProducts);
        const enteredAmountToPay = yield select(state => state.reducerShopCart.enteredAmountToPay);
        const customerAddresses = yield select(state => state.reducerCustomerAddresses.customerAddresses);

        let customerID = 0;
        var customerReq = null;
        let merchant1Amount = 0;
        let merchant2Amount = 0;

        let transaction = genfunction.convertEventstoTransaction(events, cashless, customer.CustomerID, token, donation, transactionfee.transactionFee[0], membershipPackages, gatickets, booking && booking.hasOwnProperty('BookingProducts') && booking.BookingProducts.length > 0 ? true : false, reducerBooking.booking, managebkngTicketsModify, refundType, addamount, giftcards.giftcards, bookingUDFS, orderProducts, showTransFee, donationProducts, enteredAmountToPay);
        const memberValidationReducer = yield select(state => state.reducerMemberValidation);
        let customerPostCall = true;

        let userresponse = '';
        let customerUDFsResponse = '';
        let listCustomersMemberships = null;
        let bookingTicketsResponse = '';

        if (booking && booking.hasOwnProperty('BookingProducts') && booking.BookingProducts.length > 0 && managemybooking && customers.customer && customers.customer.length > 0) {

            if (refundType !== undefined && refundType.length < 1) {
                customerReq = action.customer;
            }
        }
        else {

            if (memberValidationReducer.membervalidation && memberValidationReducer.membervalidation.MemberValidation
                && memberValidationReducer.membervalidation.MemberValidation[0].hasOwnProperty('CustomerID')) {

                action.customer[0].CustomerID = memberValidationReducer.membervalidation.MemberValidation[0].CustomerID;


                if (membershipValidation.applycostRates) {

                    customerPostCall = genfunction.CustomerPostCall(memberValidationReducer.membervalidation.MemberValidation[0], customer.GuestEmail);

                    if (customerPostCall)
                        customerID = memberValidationReducer.membervalidation.MemberValidation[0].CustomerID;
                }
            }
        }

        if (customerPostCall) {

            customerReq = action.customer;

            if (membershipPackages && membershipPackages.length > 0) {
                listCustomersMemberships = genfunction.GetCustomerList(membershipPackages, customerReq, customers, customerAddresses);
                customerReq = listCustomersMemberships.customerRequest;
            }
        }

        if (idmeshopreducer.isIdMeApplied && idmeuserdata.userdata && idmeuserdata.userdata.attributes) {

            let obj = idmeuserdata.userdata.attributes.filter(x => x.handle === 'uuid')[0];

            if (obj) {
                customerReq[0].ExtCustomerID = obj.value;
            }
        }

        //Customer 
        if (customerReq) {
            userresponse = yield fetchAsync(postmember, customerReq);

            if (userresponse == undefined || userresponse == "nocontent") {
                throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform transaction\"}]}"
            }

            if (userresponse && userresponse.length > 0) {
                customerID = userresponse[0].CustomerID;
            }
        }

        // Customer UDF's

        if (membershipPackages && membershipPackages.length > 0 && membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0
            && userresponse !== undefined) {

            let customersUdfsList = UDFs.GetCustomersListToUpdateUDFs(membershipPackages, membershipTypesUdfs.membershipUdfs, userresponse);

            if (customersUdfsList && customersUdfsList.length > 0) {
                customerUDFsResponse = yield fetchAsync(UpdateCustomerUdfs, customersUdfsList);
            }

            if (customerUDFsResponse !== "" && (customerUDFsResponse == undefined || customerUDFsResponse !== "nocontent")) {
                throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform transaction\"}]}"
            }
        }

        if (customerPostCall) {
            transaction[0].CustomerID = customerID

            if (genfunction.IsOrganization(events)) {

                let eventIndex = events.findIndex(x => x.OrganizationID !== "")

                transaction[0].CustomerID = events[eventIndex].OrganizationID;
                transaction[0].PurchaserCustomerID = customerID;

            }

        }
        else {
            transaction[0].CustomerID = memberValidationReducer.membervalidation.MemberValidation[0].CustomerID;
        }

        if (orderProducts && orderProducts.length > 0) {
            transaction[0].TransactionType = "Tab Sale";
            if (orderLocation.NodeNo) {
                transaction[0].NodeNo = orderLocation.NodeNo;
            }
            transaction[0].TabCustomerFirstName = customer.FirstName;
            transaction[0].TabCustomerLastName = customer.LastName;
            transaction[0].TabCustomerMobile = customer.CustomerAddress[0].MobilePhone;
            transaction[0].TabLocationID = orderLocation.TabLocations[0].TabLocationID;
            transaction[0].LeaveOrderOpen = false;
            transaction[0].SendToKitchen = true;
        }

        //Update Transaction Request
        if (membershipPackages && membershipPackages.length > 0) {
            transaction = genfunction.UpdateTransactionCall(listCustomersMemberships.customerList, transaction, userresponse);
        }

        if (EnableAlternateMerchantOnline && (orderProducts && orderProducts.length < 1)) {

            let merchantTotalObj = managemybooking ?

                genfunction.CalculateMultiMerchantTotalForMMB(events, cashless, (showTransFee ? transactionfee.transactionFee[0] : null), enteredAmountToPay, reducerBooking.booking) :
                genfunction.CalculateMultiMerchantTotal(events, gatickets, membershipPackages, giftcards.giftcards, donation, (showTransFee ? (transactionfee && transactionfee.transactionFee && transactionfee.transactionFee.length > 0 ? transactionfee.transactionFee[0] : null) : null), cashless, donationProducts);

            if (merchantTotalObj) {
                merchant1Amount = merchantTotalObj.merchant1Total;
                merchant2Amount = merchantTotalObj.merchant2Total;
            }
        }
        else {
            if (transaction[0].Payments[0] !== undefined && transaction[0].Payments.length > 0 && transaction[0].Payments.filter(x => x.CreditCardToken !== undefined).length > 0) {
                merchant1Amount = transaction[0].Payments.filter(x => x.CreditCardToken !== undefined)[0].PaymentAmount;
            }

            merchant2Amount = 0;
        }

        // if heap tracking is enabled, identify the customer
        if (window.heap && transaction && transaction.length > 0 && transaction[0].CustomerID)
            window.heap.identify('customer_' + transaction[0].CustomerID);

        let transactionresponse = yield fetchAsync(posttransaction, { transaction: transaction, token: token, email: customer.CustomerAddress[0].Email, customerName: customer.FirstName + ' ' + customer.LastName, recaptchav3token: recaptchaToken, primaryAmount: merchant1Amount, alternateamount: merchant2Amount, paymentType1: PaymentTypeID, paymentType2: Merchant2TypeID });

        if (transactionresponse == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform transaction\"}]}"
        else {
            transactionresponse[0].Customer = customer;
            transactionresponse[0].Events = events;
            transactionresponse[0].MembershipPackages = membershipPackages;
            transactionresponse[0].OrderProducts = orderProducts;

            if (genfunction.ShouldTrackPurchase(refundType)) {
                try {
                    if (typeof window.trackPurchaseComplete === 'function') {
                        window.trackPurchaseComplete(genfunction.BuildPurchaseTrackingPayload(transactionresponse[0]));
                    }
                } catch (e) { /* swallow - tracking must never affect payment success flow */ }
            }

            if (refundType === "CancelBooking" || refundType === "CancelGiftCardRefund") {
                transactionresponse[0].isCancelBooking = true;

                if (booking && booking.BookingID) {
                    transactionresponse[0].BookingID = booking.BookingID;
                }
            }
            else if (refundType === "AdditionalPayment") {

                let multipleBookingsTickets = [];
                reducerBooking.booking.forEach(booking => {

                    let singleBookingTickets = genfunction.ConvertBookingtoTickets(transactionresponse, booking.BookingID);
                    multipleBookingsTickets.push(singleBookingTickets)

                });

                if (genfunction.IsArrayNotEmptyNullUndefined(multipleBookingsTickets)) {
                    bookingTicketsResponse = yield fetchAsync(postbookingtickets, multipleBookingsTickets);

                    if (bookingTicketsResponse == undefined || bookingTicketsResponse == "nocontent") {
                        throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to generate tickets\"}]}"
                    }
                }
            }
            yield put({ type: START_PAYMENT_TRANSACTION_SUCCESS, payload: transactionresponse });
        }


    } catch (e) {
        yield put({ type: START_PAYMENT_TRANSACTION_ERROR, error: e });
    }
}


export const sagaPaymentTransaction = [
    takeEvery(START_PAYMENT_TRANSACTION_LOADING, SavePaymentTransactionData),

];
